import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Dots } from "../../svg";
import AddFriendSmallCard from "./AddFriendSmallCard";
import { getFriendSuggestions } from "../../functions/user";

export default function PplYouMayKnow() {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useSelector((state) => ({ ...state }));

  useEffect(() => {
    getSuggestions();
  }, []);

  const getSuggestions = async () => {
    setLoading(true);
    const res = await getFriendSuggestions(user.token);
    if (res.status === "ok") {
      setSuggestions(res.data);
    }
    setLoading(false);
  };

  const removeSuggestion = (id) => {
    setSuggestions(suggestions.filter((s) => s._id !== id));
  };

  if (loading) {
    return (
      <div className="pplumayknow">
        <div className="pplumayknow_header">
          People You May Know
          <div className="post_header_right ppl_circle hover1">
            <Dots />
          </div>
        </div>
        <div className="pplumayknow_list">
          <div className="sekelton_loader" style={{ padding: "20px" }}>
            Loading...
          </div>
        </div>
      </div>
    );
  }

  if (suggestions.length === 0) {
    return null;
  }

  return (
    <div className="pplumayknow">
      <div className="pplumayknow_header">
        People You May Know
        <div className="post_header_right ppl_circle hover1">
          <Dots />
        </div>
      </div>
      <div className="pplumayknow_list">
        {suggestions.map((suggestion) => (
          <AddFriendSmallCard
            key={suggestion._id}
            user={suggestion}
            onRemove={removeSuggestion}
          />
        ))}
      </div>
    </div>
  );
}
